<div class="jinni-carousel lottery-winners row bgc-white" *ngIf="itemsSize">
  <div class="px-sm-only-0 container xl-12 md-12 sm-12 xs-12">
    <div class="carousel-container" [ngClass]="{'done': done}">
      <div class="d-flex justify-content-between align-items-center mt-0 mt-sm-5 pt-4">
        <h1 class="color-prussian-blue px-3 tt-capitalize">{{ 'lotteryWinners.sectionTitle' | translate }}</h1>
      </div>
      <owl-carousel *ngIf="itemsSize"
                    [options]="{dotsEach: true, nav: false, checkVisible: true, lazyLoad: true, stageElement: disable, autoWidth: false, responsiveClass: true, responsive:{
                            '0':{ items:2 },
                            '1200':{ items:4 }
                            }}"
                    [items]="itemsArr"
                    [carouselClasses]="['owl-carousel','owl-theme','owl-drag', 'row']">
        <div class="item" *ngFor='let in of counter(itemsSize) ;let i = index'>
          <div class="slide pb-3 pb-sm-0 lottery-{{ valueOfIndex(i,'LotteryName') }}">
            <div class="bgp-center d-none d-sm-block logo-icon zi-1 w-100"></div>
            <div class="lottery-top">
              <div class="winner-name fw-600 fz-14px fz-sm-25px mb-2 ms-0 name l-spacing-2px text-center tt-uppercase">{{ valueOfIndex(i, 'WinnerName') }}</div>
              <div class="win-country award fw-400 fz-15px fz-sm-16px mb-4 ms-0 text-center">
                <span>{{valueOfIndex(i, 'Country')}}</span>
              </div>
              <div class="win-amt fw-400 fz-15px fz-sm-30px ms-0 mb-4 text-center">
                <span class="text-glow-red">{{valueOfIndex(i, 'WinCurrency')}} {{valueOfIndex(i, 'WinAmt')}}</span>
              </div>
              <div class="win-date fz-14px text-center">{{valueOfIndex(i, 'WinDate')}}</div>
            </div>
            <div class="logo-bg d-none"></div>
            <div class="lottery-bg box-shadow-basic {{ valueOfIndex(i,'BgType') }}"></div>
          </div>
        </div>
      </owl-carousel>
    </div>
  </div>
</div>

